import { User, Trip, Content } from './../classes.js';
import { loading_icon } from './../vars/loading_icon.js';

export function get_cookie(name){

	const nameEQ = name + "=";
	const ca = document.cookie.split(';'); // Split the string into an array of cookies
	
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') { // Remove leading spaces from the cookie string
			c = c.substring(1, c.length);
		}
		
		if (c.indexOf(nameEQ) === 0) { // Check if the cookie name matches
			// Return the value part of the string
			return JSON.parse(decodeURIComponent(c.substring(nameEQ.length, c.length))); 
		}
	}
	return false; // Return false if the cookie is not found
	
}


export function can_display(data){
	if(typeof(data) != 'undefined' && data != ''){
		return true;
	}
	return false;
}


export function form_validation(data){
	
}


export function days_between_dates(date1, date2) {
    // 1. Convert input strings/dates into absolute millisecond timestamps
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    
    // 2. Subtract timestamps to find the difference in milliseconds
    const diffInMs = Math.abs(d2 - d1);
    
    // 3. Divide by milliseconds per day and round the result
    return Math.round(diffInMs / (1000 * 60 * 60 * 24));
}


export function trigger_date_picker(default_date = ""){
	
	if(default_date == ""){
		default_date = User.info.today_as_format;
	}
	
	if($('.datepicker').length > 0){
		
		$(function() {
			if(typeof(User.info.date_format) != 'undefined'){
				$('.datepicker').datepicker({
					dateFormat: User.info.date_format,
					defaultDate: default_date
				});
			}else{
				$('.datepicker').datepicker({
					dateFormat: 'm/d/yy',
					defaultDate: default_date
				});
			}
		});
		
	}
}

export function trigger_text_editor(){
	if($('.tbw-editor')){
		$(".tbw-editor").trumbowyg({
			btnsDef: {
				// Redefine formatting to exclude h1
				formattingLight: {
					dropdown: ['p', 'h2', 'h3', 'h4', 'quote'], // Only include 'p' and 'h2'
					ico: 'p',
				}
			},
			btns: [
				['undo', 'redo'], // Only supported in Blink browsers
				['formattingLight'],
				['strong', 'em', 'del'],
				['unorderedList', 'orderedList'],
				['horizontalRule'],
				['removeformat']
			]
			, removeformatPasted: true
			, resetCss: true
			, tagsToRemove: ['script', 'link']
			, autogrow: true
		});
	}
}



export function trigger_sort(){
	
	$(".trip__block--edit").sortable({
		items: '.e'
		, handle: '.options .drag'
		, update: function() {
			order_sort();
		}
	});
	
	$(".the_content").sortable({
		items: '.e'
		, handle: '.options .drag'
		, update: function() {
			content_sort();
		}
	});
	
	$(".gallery_images").sortable({
		items: '.gallery_image'
		, handle: '.drag-gallery-image'
		, update: function() {
			gallery_sort($(this));
		}
	});
	
}


export function order_sort(){
	let b = 1;
	let i = 1;
	let block_id = 0;
	let el_id = 0;
	
	//update order of each block
	$(".trip__block--edit").each(function(index){
		//update for database
		$(this).find('.block_order').val(b);
		
		//update for object
		block_id = $(this).attr('data-block_id');
		Trip.content.b[block_id].order = b;
		
		b++;
		
		//update order of each element
		i = 1;
		$(this).find('.e').each(function(index){
			//update for database
			$(this).find('.element_order').val(i);
			
			//update for object
			el_id = $(this).attr('data-el_id');
			Trip.content.b[block_id].e[el_id].order = i;
			
			i++;
		});
		
	});
}

export function content_sort(){
	let b = 1;
	let i = 1;
	let block_id = 0;
	let el_id = 0;
	
	//update order of each element
	i = 1;
	$('.the_content').find('.e').each(function(index){
		//update for database
		$(this).find('.element_order').val(i);
		
		//update for object
		el_id = $(this).attr('data-el_id');
		Content.content.e[el_id].order = i;
		
		i++;
	});
		
}

export function gallery_sort(target){
	console.log(target);
	let array_val = Array();
	
	target.find('.gallery_image').each(function(index){
		array_val.push($(this).data('media'));
	});
	
	target.closest('.editable').find('.media_gallery').val(array_val.join());
}


export function random_string(length){
	
	var result = '';
	var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
	for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
	return result;
	
}

export function strip_html(html) {
	const smart_remove = html
	  .replace(/<[^>]*>/g, ' ')
	  .replace(/\s{2,}/g, ' ')
	  .trim();
	
	const doc = new DOMParser().parseFromString(smart_remove, 'text/html');
	return doc.body.textContent || "";
}

export function screen_size_handler(){
	
	window.render_size = $(window).width();
	
	if($(window).width() < 769){
		window.is_mobile = true;
	}else{
		window.is_mobile = false;
	}
	
	$('.card__slider_nav--prev').fadeOut(500);
	$('.card__slider_nav--prev').removeClass('active');
	$('.card__slider_nav--next').fadeIn(500);
	$('.card__slider_nav--next').addClass('active');
	if(window.is_mobile){
		
		$('.card__slider_content').animate({
			left: 0,
		}, 0);
		$('.card__slider_content').animate({
			maxHeight: '66vh',
		}, 0);
		
	}else{
		
		$('.card__slider_content').animate({
			left: 0,
		}, 0);
		$('.card__slider_content').animate({
			maxHeight: 'none',
		}, 0);
		
	}
	
}


export function start_loading(message, loading = true) {
	let $loader = $('<div/>', {
			'class': 'processing_notice',
			'html': `${loading_icon} ${message}`
		});
		
	if(!loading){
		$loader.html(message);
	}
	
	console.log('show loader');
	$('body').append($loader);
}

export function end_loading(message) {
	console.log('close loader');
	
	$('.processing_notice').html(message);
	
	setTimeout(function() {
		// Your jQuery action goes here
		$('.processing_notice').fadeOut();
	}, 700);
	
	setTimeout(function() {
		$('.processing_notice').remove();
	}, 2000);
}

export function event_timestamp(dateStr) {
	// Regex to extract: month, day, year, hours, minutes, am/pm
	const regex = /(\d{2})\/(\d{2})\/(\d{4})\s+(\d{1,2}):(\d{2})\s+(am|pm)/i;
	const match = dateStr.match(regex);

	if (!match) return null;

	const [_, month, day, year, hourStr, minutes, amPm] = match;

	let hours = parseInt(hourStr, 10);

	// Convert 12-hour format to 24-hour format
	if (amPm.toLowerCase() === 'pm' && hours < 12) hours += 12;
	if (amPm.toLowerCase() === 'am' && hours === 12) hours = 0;

	// JavaScript months are 0-indexed (0 = Jan, 8 = Sep)
	const dateObj = new Date(year, parseInt(month, 10) - 1, day, hours, minutes);

	// Returns number of milliseconds since 1970 (e.g., 1789899000000)
	return dateObj.getTime(); 
}